import { CREATE_USER_PREFERENCE, GET_EMAIL_TEMPLATE, GET_USER_PREFERENCES } from "./constants";

export function getUserPreferencesAction() {
  return {
    type: GET_USER_PREFERENCES,
  };
}

export function getEmailTemplateAction() {
  return {
    type: GET_EMAIL_TEMPLATE,
  };
}

export function createUserPreferenceAction(payload, onSuccess) {
  return {
    type: CREATE_USER_PREFERENCE,
    payload,
    onSuccess
  };
}